import { twMerge } from "tailwind-merge";
import { theme } from "../../../utilities/theme";

interface SelectBoxProps<T extends string> {
  onSelect: (value: T) => void;
  label?: string;
  value: T;
  options: {
    label: string;
    value: T;
  }[];
  className?: string;
}

export default function SelectBox<T extends string>({
  onSelect,
  value,
  options,
  label,
  className,
}: SelectBoxProps<T>) {
  const isUnselected = !value;

  return (
    <div className="flex max-h-full flex-col gap-1">
      {label && <p className="text-lg font-bold">{label}</p>}
      <select
        className={twMerge(
          "relative h-[40px] min-w-[130px] appearance-none rounded-md border border-zinc-300 bg-white px-2 outline-none focus:border-black",
          isUnselected && "text-zinc-500",
          className
        )}
        style={{
          background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5"><path fill="${encodeURIComponent(
            theme.color.darkGray
          )}" d="M0 0h10L5 5z"/></svg>') no-repeat right 10px center`,
          backgroundColor: "white",
          backgroundSize: "10px 5px",
        }}
        onChange={(event) => onSelect(event.target.value as T)}
        value={value}
      >
        {options.map((option) => {
          return (
            <option
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
